type MenuSection = {
  title: string;
  categories: { path: string; activePaths?: string[] }[];
};

const normalizePath = (path: string) =>
  path.split(/[?#]/)[0].replace(/\/+$/, "") || "/";

export function findActiveMenuRoute(
  categories: MenuSection[],
  pathname: string,
) {
  const currentPath = normalizePath(pathname);
  return categories
    .flatMap(({ title, categories: links }) =>
      links.flatMap(({ path, activePaths = [] }) =>
        [path, ...activePaths].map((matchPath) => ({
          section: title,
          path,
          matchPath: normalizePath(matchPath),
        })),
      ),
    )
    .filter(
      ({ matchPath }) =>
        currentPath === matchPath ||
        (matchPath !== "/" && currentPath.startsWith(`${matchPath}/`)),
    )
    .sort((a, b) => b.matchPath.length - a.matchPath.length)[0];
}
